import { render, staticRenderFns } from "./video-recording-data.html?vue&type=template&id=2df0f134&scoped=true&external"
import script from "./video-recording-data.js?vue&type=script&lang=js&external"
export * from "./video-recording-data.js?vue&type=script&lang=js&external"
import style0 from "./video-recording-data.scss?vue&type=style&index=0&id=2df0f134&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df0f134",
  null
  
)

export default component.exports